"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "102", height: "102", viewBox: "0 0 102 102", className: "Icon milanote-logo-large", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { stroke: "#F4511C", fill: "none", strokeLinejoin: "round", strokeLinecap: "round", fillRule: "evenodd", strokeWidth: "2.5" },
            _react2.default.createElement("path", { d: "M51 100C23.938 100 2 78.062 2 51S23.938 2 51 2s49 21.938 49 49-21.938 49-49 49z" }),
            _react2.default.createElement("path", { d: "M72.359 72.359L29.641 29.641v42.718h42.718V29.641L29.641 72.359" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/milanote-logo-large.js
// module id = 1813
// module chunks = 0